import { useState, useEffect } from "react";

const navItems = ["Home", "About", "Products", "Features", "Contact"];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo + Name */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollTo("home")}>
          <img
            src="https://public.readdy.ai/ai/img_res/dcb3dcf6-6b60-485e-94ca-230cc19e0552.png"
            alt="BAZA DOO BECEJ Logo"
            className="w-9 h-9 object-contain"
          />
          <span
            className={`font-bold text-sm md:text-base tracking-wide whitespace-nowrap transition-colors duration-300 ${
              scrolled ? "text-gray-900" : "text-white"
            }`}
          >
            BAZA DOO BECEJ
          </span>
        </div>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <li key={item}>
              <button
                onClick={() => scrollTo(item)}
                className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap hover:opacity-70 ${
                  scrolled ? "text-gray-700" : "text-white/90"
                }`}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer ${
            scrolled ? "text-gray-900" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-5 h-0.5 bg-current transition-all ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-5 h-0.5 bg-current transition-all ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-5 h-0.5 bg-current transition-all ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item)}
              className="text-sm font-medium text-gray-700 text-left cursor-pointer hover:text-gray-900 whitespace-nowrap"
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
